// Privacy API Values: https://web.developer.smartlook.com/docs/privacy-api
export const enum Privacy {
  MASK = 'mask',
}

// identify interactions with specific elements within the app so we can filter on in smartlook
export const enum CustomEvent {
  ACTION_REQUIRED = 'sl-action-required',
  ELIGIBILITY_GUIDANCE = 'sl-eligibility-guidance',
  HOMEPAGE_V2 = 'sl-homepage',
  MEMBER_ACTIVATION_VERIFY_INFO = 'sl-activation-verify-information',
  MISO_RECOMMENDATIONS = 'sl-miso-test',
  STORE_LANDING = 'sl-store-landing-test',
  VARIATION = 'sl-variations-dropdown',
}
